import React, { useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import AlertService from '../../../components/Alerts/alerts';
import DashboardService from "../dashboard.service";

const AddTopUp = ({ onClose }) => {
    const [topUpAmount, setTopUpAmount] = useState('');
    const [loading, setLoading] = useState(true);

    const handleTopUp = async () => {
        try {
            setLoading(true);
            const userString = localStorage.getItem('user');
            const user = JSON.parse(userString);
            const userId = user['_id'];
            console.log('Top-up amount:', topUpAmount);
            let data = {
                user_id: userId,
                amount: topUpAmount,
                type: 'Topup',
                date: new Date()
            }
            const response = await DashboardService.AddTopUp(data);
            if (response.status === 200) {
                window.open(response.data.data, '_blank');
                AlertService.successToast("Order Placed Now Pay to Proceed.");
                window.location.reload();
            } else {
                window.open(response.data.data, '_blank');
            }
        } catch (err) {
            console.error('Error placing order:', err);
            AlertService.swalErrorAlert("Failed to place order. Please try again.");
        } finally {
            setLoading(false);
        }

        onClose();
    };

    const handleOutsideClick = useCallback((e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    }, [onClose]);

    const handleAmountSelect = (amount) => {
        setTopUpAmount(amount);
    };

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
        },
        popup: {
            width: '90%',
            maxWidth: '500px',
            backgroundColor: 'white',
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px',
            borderBottom: '1px solid #eee',
        },
        content: {
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        title: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
        amountButton: (isSelected) => ({
            width: '200px',
            padding: '10px',
            margin: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            textAlign: 'center',
            cursor: 'pointer',
            backgroundColor: isSelected ? '#F63E3D' : 'white',
            color: isSelected ? 'white' : 'black',
        }),
        input: {
            width: '200px',
            padding: '10px',
            margin: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
        },
        topUpButton: (isDisabled) => ({
            width: '200px',
            padding: '10px',
            margin: '20px 10px',
            backgroundColor: isDisabled ? '#ccc' : '#F63E3D',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? 0.5 : 1,
        }),
    };

    return (
        <div style={styles.overlay} onClick={handleOutsideClick}>
            <div style={styles.popup}>
                <div style={styles.header}>
                    <FontAwesomeIcon icon={faArrowLeft} onClick={onClose} style={{ cursor: 'pointer' }} />
                    <span style={styles.title}>Topup</span>
                    <FontAwesomeIcon icon={faShoppingCart} />
                </div>
                <div style={styles.content}>
                    <h3>1. Select a top-up value</h3>
                    {['20.00', '50.00', '100.00'].map((amount) => (
                        <button
                            key={amount}
                            style={styles.amountButton(topUpAmount === amount)}
                            onClick={() => handleAmountSelect(amount)}
                        >
                            {amount}
                        </button>
                    ))}
                    <p>or enter topup amount</p>
                    <input
                        type="number"
                        style={styles.input}
                        value={topUpAmount}
                        onChange={(e) => setTopUpAmount(e.target.value)}
                        placeholder="Enter amount"
                    />
                    <button
                        style={styles.topUpButton(!topUpAmount)}
                        onClick={handleTopUp}
                        disabled={!topUpAmount}
                    >
                        Top-up Now
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddTopUp;